import { SquareAsterisk } from 'lucide-react'
import { createLazyComponent } from 'v2/shared/utils/lazy-utils'
import { agentsDenialReason, canViewAgents } from 'v2/shared/utils/role-based-visibility'
import type { IRoute } from 'v2/types'
import type { RFeatureFlags, UserRole } from 'v2/types/api/auth'
import type { ModulePermissionTypeMap } from 'v2/types/rbac'

// Lazy-loaded components
const SecretsPage = createLazyComponent(() => import('v2/pages/flow/secrets'))

// Direct import - no lazy loading for agent builder
import AgentBuilder from 'v2/pages/flow/agent-builder'
import { AGENT_BUILDER_BASE_PATH } from 'v2/pages/flow/utils/agent-builder-route'

export const getAiStudioRoutes = (meta?: {
  featureFlags?: RFeatureFlags
  roles?: UserRole[]
  permissionsMap?: ModulePermissionTypeMap
  location?: string
}): IRoute[] => [
  {
    title: 'Secret Variables',
    path: '/agent/secrets',
    icon: <SquareAsterisk size={16} />,
    component: <SecretsPage />,
    hidden: meta?.location?.includes('/agent/legacy'),
    notAllowed: !canViewAgents(meta),
    accessDenialReason: agentsDenialReason(meta),
  },
  // Hidden routes for agent functionality
  {
    title: 'Legacy agents',
    path: '/agent/legacy/:id',
    hidden: true,
  },
  {
    title: 'Agent builder',
    path: `${AGENT_BUILDER_BASE_PATH}/:id/*`,
    component: <AgentBuilder />,
    hidden: true,
    notAllowed: !canViewAgents(meta),
    accessDenialReason: agentsDenialReason(meta),
  },
]
